import { useSetupStore } from '../../store/setupStore';

const ClassFrequencyStep = () => {
  const { setup, updateSetup } = useSetupStore();

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">Class Frequency</h2>
      <p className="text-gray-600">
        Set how often your classes meet and the total number of classes.
      </p>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            How often do classes meet?
          </label>
          <select
            value={setup.frequency}
            onChange={(e) => updateSetup({ frequency: e.target.value as any })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="biweekly">Bi-weekly</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Total number of classes
          </label>
          <input
            type="number"
            min="1"
            value={setup.totalClasses}
            onChange={(e) =>
              updateSetup({ totalClasses: parseInt(e.target.value) })
            }
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
          />
        </div>
      </div>
    </div>
  );
};

export default ClassFrequencyStep;